import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import {
  IEditInvoice,
  IInvoice,
  IParamsGetInvoices,
  IPayloadDeleteInvoice,
  IResponseGetInvoices,
} from '~/utils/interface/invoice';

const invoiceApi = {
  getInvoices(params: IParamsGetInvoices) {
    return axiosClient.get<IApiBaseResponse<IResponseGetInvoices>>(`api/admin/invoices`, { params });
  },

  create(data: IEditInvoice) {
    return axiosClient.post<IApiBaseResponse<IInvoice>>(`api/admin/invoices`, data);
  },

  getInvoice(id: string) {
    return axiosClient.get<IApiBaseResponse<IInvoice>>(`api/admin/invoices/${id}`);
  },

  update(id: string, data: IEditInvoice) {
    return axiosClient.put<IApiBaseResponse<IInvoice>>(`api/admin/invoices/${id}`, data);
  },

  delete(data: IPayloadDeleteInvoice) {
    return axiosClient.delete<IApiBaseResponse<null>>('api/admin/invoices', { data });
  },

  export(id: string) {
    return axiosClient.get<IApiBaseResponse<null>>(`api/admin/invoices/export/${id}`, { responseType: 'blob' });
  },
};

export default invoiceApi;
